"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { Popover } from "@base-ui/react/popover";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { DrawerHandle } from "../Drawer/DrawerHandle.js";
import { popoverVariants } from "./Popover.variants.js";
import { usePopoverMode } from "./PopoverContext.js";
const PopoverPopup_PopoverPopup = /*#__PURE__*/ forwardRef(function({ className, size, scroll, stickyFooter, customHeader, customFooter, customBody, noHeading, slots, ...props }, ref) {
    const mode = usePopoverMode();
    const { popup, popupAnimation, drawerPopup, viewport } = popoverVariants({
        size,
        scroll,
        stickyFooter,
        customHeader,
        customFooter,
        customBody,
        noHeading
    });
    if ('drawer' === mode) {
        const drawerPopupClasses = cn(drawerPopup(), className, slots?.popup);
        const { children, ...drawerProps } = props;
        return /*#__PURE__*/ jsx(Drawer.Viewport, {
            className: cn(viewport(), slots?.viewport),
            children: /*#__PURE__*/ jsxs(Drawer.Popup, {
                ref: ref,
                "data-mode": "drawer",
                className: drawerPopupClasses,
                ...drawerProps,
                children: [
                    /*#__PURE__*/ jsx(DrawerHandle, {}),
                    children
                ]
            })
        });
    }
    const popupClasses = cn(popup(), popupAnimation(), className, slots?.popup);
    return /*#__PURE__*/ jsx(Popover.Popup, {
        ref: ref,
        "data-mode": "popover",
        className: popupClasses,
        ...props
    });
});
export { PopoverPopup_PopoverPopup as PopoverPopup };
